// src/utils/aiApi.js
//const AAPI_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080/api';
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://brasotechgobackend-production.up.railway.app/api';


export const aiApi = {
  async askQuestion(question, sessionId = null) {
    try {
      const response = await fetch(`${API_BASE_URL}/ai/ask`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          question,
          session_id: sessionId
        }),
      });

      if (!response.ok) {
        throw new Error('Failed to get AI response');
      }

      return await response.json();
    } catch (error) {
      console.error('AI API Error:', error);
      throw error;
    }
  },

  async createSession() {
    try {
      const response = await fetch(`${API_BASE_URL}/ai/session`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error('Failed to create session');
      }

      return await response.json();
    } catch (error) {
      console.error('Session API Error:', error);
      throw error;
    }
  },

  async clearSession(sessionId) {
    try {
      const response = await fetch(`${API_BASE_URL}/ai/session/${sessionId}`, {
        method: 'DELETE',
      });

      if (!response.ok) {
        throw new Error('Failed to clear session');
      }

      return await response.json();
    } catch (error) {
      console.error('Clear Session Error:', error);
      throw error;
    }
  },

  async checkHealth() {
    try {
      const response = await fetch(`${API_BASE_URL}/ai/health`);
      return await response.json();
    } catch (error) {
      console.error('Health Check Error:', error);
      return { status: 'unavailable' };
    }
  }
};